<template>
  <div>
    <dara-form v-if="trackEditVm.track" :submit="save">
      <div class="form-field mt-4">
        {{ $t('tracks-name') }}*
        <dara-input
          v-model="trackEditVm.track.name"
          :name="$t('track-name-field')"
          type="text"
          rules="required|min:2"
          :placeholder="$t('track-name-placeholder')" />
      </div>
      <div class="form-field">
        {{ $t('description') }}*
        <dara-input
          v-model="trackEditVm.track.description"
          :name="$t('description-field')"
          type="text"
          rules="required|min:2"
          :placeholder="$t('track-description-placeholder')" />
      </div>

      <dara-row class="align-items-center">
        <dara-col :xs="24" :span="12" justify="left">
          {{ $t('access') }}*
          <dara-select
            v-bind="$attrs"
            :name="$t('access-field')"
            rules="required"
            :value="trackEditVm.track.access"
            class="mt-1 mb-0"
            @on-change="onAccessChange">
            <option :value="null" disabled>{{ $t('select-access') }}</option>
            <option
              v-for="access in all_access"
              :key="access.name"
              :value="access.value">
              {{ access.name }}
            </option>
          </dara-select>
          <small class="text-muted dara-u-text--small d-block mt-1 mb-3">
            {{ $t(accessesInfo[trackEditVm.track.access]) }}
          </small>
        </dara-col>
        <dara-col :xs="24" :span="12">
          <dara-department-chooser
            ref="departmentChooser"
            v-model="trackEditVm.track.department_id"
            @on-change="onDepartmentChange"
            @onNewDepartment="onNewDepartment" />
        </dara-col>
      </dara-row>

      <div class="mt-4 mb-3 d--flex justify-content-end">
        <dara-button
          class="btn btn-secondary"
          width="110"
          size="sm"
          @click="goHistoryBack()">
          {{ $t('cancel') }}
        </dara-button>
        <dara-button
          native-type="submit"
          class="btn btn-success ms-2"
          width="110"
          size="sm">
          <a v-if="trackEditVm.track.id">{{ $t('update') }}</a>
          <a v-else>{{ $t('save') }}</a>
        </dara-button>
      </div>
    </dara-form>

    <dara-modal-new-department
      v-if="showModal()"
      ref="departmentModal"
      @close="closeModal()">
    </dara-modal-new-department>
  </div>
</template>

<script>
import { goHistoryBack } from '@/router/route.service';
import { TRACK_ACCESS_INFO } from '@/modules/track/track.constants';
import { translate } from '@/services/translate.service';
import DaraDepartmentChooser from '@/modules/department/components/DepartmentChooser.vue';

export default {
  name: 'DaraTrackEdit',
  components: {
    DaraDepartmentChooser,
  },
  inject: ['trackEditVm'],
  data() {
    return {
      all_access: [
        { name: translate('public'), value: 0 },
        { name: translate('department-only'), value: 1 },
      ],
      newDepartment: false,
      accessesInfo: TRACK_ACCESS_INFO,
    };
  },
  methods: {
    goHistoryBack,
    save() {
      this.$emit('save');
    },
    onAccessChange(access) {
      this.$set(this.trackEditVm.track, 'access', access);
    },
    onDepartmentChange(department) {
      this.$set(this.trackEditVm.track, 'department_id', department.id);
    },
    onNewDepartment() {
      this.newDepartment = true;
    },
    showModal() {
      return this.newDepartment;
    },
    closeModal() {
      this.$refs.departmentChooser.onfetch();
      this.newDepartment = false;
    },
  },
};
</script>
